/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const diamond = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#diamond_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.31 1.61a.989.989 0 0 1 .342.306l2.154 3.086c.131.188.2.417.194.651M12.31 1.61a.916.916 0 0 0-.433-.11H4.125a.915.915 0 0 0-.434.11m8.62 0-1.353 4.043M3.691 1.61a.989.989 0 0 0-.342.306L1.194 5.002c-.131.188-.2.417-.194.651M3.691 1.61l1.352 4.043M1 5.653c.006.234.085.46.225.64l6.032 7.835c.182.233.46.372.743.372M1 5.653h4.043M8 14.5c.283 0 .561-.14.743-.372l6.032-7.836c.14-.18.22-.405.225-.639M8 14.5 5.043 5.653M8 14.5l2.958-8.847m4.042 0h-4.042m-5.915 0h5.915"
      />
    </g>
    <defs>
      <clipPath id="diamond_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default diamond
